module.exports = __webpack_public_path__ + "static/img/zhongwu01.dac8de29.jpg";